import Grid from '@mui/material/Grid';
import { useDevice } from 'components/DeviceContext.js';
import { RedesSociaisLaranja } from 'components/RedesSociais';


function Estaduais() {
    const { isMobile } = useDevice();
    return (
        <>
            <Grid style={{
                display: 'flex',
                justifyContent: 'center',
                margin: isMobile ? '3em' : '4em 0',
                flexWrap: 'wrap',
            }}>
                <Grid item xs={12} md={5} lg={6}
                    style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                    <img src="https://cnm.org.br/storage/noticias/2023/Imagens/Institucional/estaduaisAtualizadas.png" alt='Imagem com as logos atualizadas das Estaduais' style={{
                        width: isMobile ? '100%' : '80%',

                    }} />

                </Grid>
                <Grid item xs={12} md={2} lg={2}>
                    <img src="https://cnm.org.br/img/cnm.svg" alt='Logo CNM' style={{
                        width: isMobile ? '0' : '0'
                    }} />
                    <RedesSociaisLaranja style={{with: ''}}/>

                </Grid>

            </Grid>
        </>

    )
}

export default Estaduais;
